import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileLines, faTriangleExclamation} from "@fortawesome/free-solid-svg-icons";/*faCircleUser, faCircleInfo, faFolder, faAddressBook, faKey*/
import React, {useEffect, useRef, useState} from 'react';
import './budget.scss'
import {Button} from "devextreme-react/button";
import notify from "devextreme/ui/notify";
import {
    daDataGet,
} from "../../api/newdog";
import {
    getContracts,
    getModes,
    getPurchaseReasons,
    getFundSources,
    getTreasuries,
    addContract,
    getRequestAttach
} from "../../api/budget";
import CustomStore from "devextreme/data/custom_store";
import {TextBox} from "devextreme-react";
import LoadPanel from "devextreme-react/load-panel";
import {SelectBox} from "devextreme-react/select-box";
import Accordion, {Item as AccItem} from "devextreme-react/accordion";
import Form, {
    CompareRule, CustomRule, EmailRule, GroupItem, Item, Label, PatternRule, StringLengthRule
} from "devextreme-react/form";
import ErrorPopup from "../../components/error-popup/error-popup";
import {useHistory} from "react-router-dom";
import {Buffer} from "buffer";
import {getParamsFromResource} from "../../api/request";
import NewdogFiles from "../../components/newdog-files/newdog-files";
import {useAuth} from "../../contexts/auth";
import {MONEY_FORMAT, VOLUME_FORMAT, PRICE_KWH_FORMAT} from "./number-formats";



const isFormValid = (ref) => {
    const result = ref.current?.instance?.validate?.()
    if (!result) return true
    return result.isValid
}

const AddContractPage = () => {
    //region contract
    let formRef = [useRef(null), useRef(null), useRef(null), useRef(null)]
    const history = useHistory();
    const {selectedDog} = useAuth()
    const [triangle, setTriangle] = useState(false)

    const accordionRef = useRef(null);
    const [disabledForms, setDisabledForms] = useState(false)
    const [validateRequired, setValidateRequired] = useState(false)
    const validateRequiredRef = useRef(false)
    const setValidateRequiredFlag = (value) => {
        validateRequiredRef.current = !!value
        setValidateRequired(!!value)
    }
    const requiredWhenSubmitting = (e) => {
        if (!validateRequiredRef.current) return true
        const v = e?.value
        return !(v === undefined || v === null || v === '')
    }

    const [loading, setLoading] = useState(false)
    const [reqs, setReqs] = useState([])
    const [selectedReq, setSelectedReq] = useState({})

    const [popupErrorVisible, setPopupErrorVisible] = useState(false);
    const [popupErrorText, setPopupErrorText] = useState('');
    const [popupIcon, setPopupIcon] = useState(null);
    const [popupTitle, setPopupTitle] = useState("Ошибка");
    const [popupWidth, setPopupWidth] = useState(500);
    const [popupClassNameColorIcon, setPopupClassNameColorIcon] = useState(null);
    const [onOk, setOnOk] = useState(null);
    const onCancel= () => {setPopupErrorVisible(false)};
    const onCancelWithOk = () => {setPopupErrorVisible(false)};
    const [btnVisibleCancel, setBtnVisibleCancel] = useState(false);
    const [didLoad, setDidLoad] = useState(false);
    const [policyUrl, setPoilicyUrl] = useState('')
    const [visibleAddOldFiles, setVisibleAddOldFiles] = useState(false)
    const [dogDocList, setDogDocList] = useState([])
    const [newdogFiles, setNewdogFiles] = useState(new Map())
    //endregion

    const [contractTypes, setContractTypes] = useState([])
    const [reasonList, setReasonList] = useState([])
    const [fundSourceList, setFundSourceList] = useState([])
    const [treasuryList, setTreasuryList] = useState([])

    useEffect(() => {
        (async function () {
            const resContractTypes = await getModes()
            if (resContractTypes.isOk) setContractTypes(resContractTypes.data)

            const resReasons = await getPurchaseReasons()
            if (resReasons.isOk) setReasonList(resReasons.data)

            const resFundSources = await getFundSources()
            if (resFundSources.isOk) setFundSourceList(resFundSources.data)

            const resTreasuries = await getTreasuries()
            if (resTreasuries.isOk) setTreasuryList(resTreasuries.data)

            const resPolicy = await getParamsFromResource('POLICY_URL')
            if (resPolicy.isOk) setPoilicyUrl(resPolicy.data)
        })();
    }, [])

    const onSendRequest = async (validate) => {
        if (selectedReq.id?.toString().includes('-temporare')) {
            delete selectedReq.id;
        }
        if (validate) {
            setValidateRequiredFlag(true)
            if (!(await validForms())) {
                return
            }
            selectedReq.status = 1
            setValidateRequiredFlag(false)
        } else {
            setValidateRequiredFlag(false)
            selectedReq.status = 10
        }
        formRef.forEach((ref) => {
            const data = ref?.current?.instance?.option('formData')
            if (data && typeof data === 'object') Object.assign(selectedReq, data)
        })
        const fd = new FormData()
        Object.entries(selectedReq).forEach(([key, value]) => {
            if (value === undefined || value === null || value === '') return
            if (typeof value === 'boolean') {
                fd.append(key, value ? 'true' : 'false')
                return
            }
            fd.append(key, toFormDateValue(value))
        })
        await addFiles(fd)
        try {
            setLoading(true)
            await createOrUpdateDogovor(fd)
        } catch (e) {
            notify(e.message, 'error', 5000)
        } finally {
            setLoading(false)
        }
    }

    const showNotify = async (text, title = 'Ошибка') =>{
        setPopupErrorText(text)
        setPopupIcon(faTriangleExclamation)
        setPopupTitle(title)
        setPopupClassNameColorIcon('main-color-light')
        setPopupWidth(500)
        setPopupErrorVisible(true)
        setBtnVisibleCancel(false)
        setOnOk(() => () => {
            setPopupErrorVisible(false)
        })
    }

    const toFormDateValue = (value) => {
        if (value instanceof Date && !Number.isNaN(value.getTime())) {
            const y = value.getFullYear()
            const m = String(value.getMonth() + 1).padStart(2, '0')
            const d = String(value.getDate()).padStart(2, '0')
            return `${y}-${m}-${d}`
        }
        return value
    }

    const saveOneFieldOnBlurFocus = async (key, value) => {
        setValidateRequiredFlag(false)
        if (key !== 'bank' && value === null) return
        if (key === 'bank' && value === null) value = ''
        value = toFormDateValue(value)
        const fd = new FormData()
        fd.append("status",10)
        fd.append(key,value)
        if (!selectedReq.id?.toString().includes('-temporare')) {
            fd.append('id', selectedReq.id)
        }
        fd.append('kod_dog',selectedReq.kod_dog)
        try {
            await createOrUpdateDogovor(fd)
        } catch (e) {
            notify(e.message, 'error', 5000)
        }
    }

    const createOrUpdateDogovor = async(fd) =>{
        let result;
        if (fd.get('id')){
            // update заявки
            result = await addContract(fd)
            if (result.isOk) {
                // если в заявке есть файлы получаем новый selectedReq чтобы обновилась форма с файлами
                const fdnew = Object.fromEntries(fd)
                if (fdnew.document || +result.status === 1) {
                    await getListZayavka()
                }
                Object.keys(fdnew).length > 4 && notify(result.message, 'success', 5000)
            } else {
                notify(result.message, 'error', 5000)
                return result
            }
        } else {
            const prevId = selectedReq.id
            const kodDog = selectedReq.kod_dog
            const nextStatus = Number(fd.get('status')) || 10
            selectedReq.status = nextStatus
            result = await addContract(fd)
            if (result.isOk) {
                const newId = result.id != null ? result.id : prevId
                if (newId != null) {
                    selectedReq.id = newId
                    setSelectedReq((prev) => ({ ...prev, id: newId, status: nextStatus }))
                    setReqs((list) => (list || []).map((row) => {
                        if (prevId != null && row.id === prevId) {
                            return { ...row, id: newId, status: nextStatus }
                        }
                        if (
                            (prevId == null || String(prevId).includes('-temporare'))
                            && Number(row.kod_dog) === Number(kodDog)
                            && String(row.id || '').includes('-temporare')
                        ) {
                            return { ...row, id: newId, status: nextStatus }
                        }
                        return row
                    }))
                }
                notify(result.message, 'success', 3000)
                const fdnew = Object.fromEntries(fd)
                // Полный reload только для файлов/отправки — выбор уже с реальным id.
                if (fdnew.document || +result.status === 1) {
                    await getListZayavka()
                }
            } else {
                notify(result.message, 'error', 5000)
            }
        }
    }

    const pickInitialContract = (list) => {
        if (!list?.length) return null
        const kodDog = selectedDog?.kodDog
        if (kodDog != null) {
            const match = list.find((e) => Number(e.kod_dog) === Number(kodDog))
            if (match) return match
        }
        return list[0]
    }

    const withFormDefaults = (e) => ({
        ...e,
        incl_plan_vol: e.incl_plan_vol === true,
        accepted: e.accepted === true,
    })

    const getListZayavka = async () => {
        setLoading(true)
        const res = await getContracts('prolongation')
        res.data?.forEach((item) => {
            if (item.id === null) {
                item.id = (typeof crypto?.randomUUID === 'function' ? crypto.randomUUID() : window.crypto.getRandomValues(new Uint8Array(16)).join('')) + "-temporare"
            }
        })
        if (res.isOk) {
            res.data = res.data?.map(withFormDefaults)
            setReqs(res.data)
            if (res.data && res.data.length > 0 && !selectedReq?.id) {
                const initial = pickInitialContract(res.data)
                setSelectedReq(initial)
                setDisabledForms(false)
            } else if (res.data && res.data.length > 0) {
                const obj = res.data.find((e) => e.id === selectedReq.id)
                if (obj) {
                    setSelectedReq(obj)
                    setDisabledForms(false)
                } else {
                    const initial = pickInitialContract(res.data)
                    setSelectedReq(initial)
                    setDisabledForms(false)
                }
            } else if (res.data && res.data.length === 0) {
                setSelectedReq({})
                setDisabledForms(true)
            }
        } else {
            notify(res.message,'error',10000)
        }
        setLoading(false)
    }

    useEffect(() => {
        (async function(){
            if (!didLoad) {
                setDogDocList([{id: 0, nameType: "Документ к заявлению", dogkindId: "0", needUse: "0", fillOrder: "100", info: null}])
                await getListZayavka()
                setDidLoad(true);
            }
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[didLoad])

    /* eslint-disable */
    useEffect(() => {
        (async function(){
            await openAllItems();
            await closeAllItems()
        })();
    },[])
    /* eslint-enable */

    // Функция для открытия всех элементов аккордеона
    const openAllItems = async () => {
        if (accordionRef.current) {
            const instance = accordionRef.current.instance;
            // Устанавливаем все индексы как открытые
            formRef.forEach((e,index) => {
                instance.expandItem(index)
            });
        }
    };

    // Функция для закрытия всех элементов аккордеона
    const closeAllItems = async () => {
        if (accordionRef.current) {
            const instance = accordionRef.current.instance;
            // Устанавливаем пустой массив для закрытия всех элементов
            instance.option('selectedItemKeys', []);
            instance.expandItem(0)
        }
    };

    // валидация форм
    const validForms = async () => {
        // boolFormRef === undefined → все формы обнаружены
        let boolFormRef = formRef.find(e => {
            return !e.current
        })
        if (!boolFormRef) {
            // валидируем все формы
            let result = formRef.map(e => {
                return e.current.instance.validate()
            })
            boolFormRef = result.find(e => {
                return !e.isValid
            })
            setTriangle(result.every(e => e.isValid))
            if (!boolFormRef) {
                return true
            } else {
                let messageError = ''
                result.map(e => {
                    return e.brokenRules.map(rule => {
                        messageError += '<li>' + rule.message + '</li>'
                        return null
                    })
                })
                await showNotify(`<ol>${messageError}</ol>`)
                return false
            }
        }
    }

    const dateOptions = {
        displayFormat: 'dd.MM.yyyy',
        useMaskBehavior: true,
        openOnFieldClick: true,
    }

    const bankStore = new CustomStore({
        key: 'bic',
        useDefaultSearch: true,
        load: (loadOptions) => {
            if (loadOptions.filter) {
                return daDataGet(loadOptions?.filter[0][2], 'bank')
                    .then((response) => {
                        const suggestions = response?.data?.suggestions || [];
                        const mappedData = suggestions.map((item) => ({
                            ...item,
                            bic: item.data?.bic,
                        }));
                        return { data: mappedData };
                    })
                    .catch(() => {
                        throw new Error('Data Loading Error');
                    });
            }
        },
    });

    const selectionChangedBank = async (e) => {
        e.selectedItem?.data?.name?.payment && await saveOneFieldOnBlurFocus('bank', e.selectedItem?.data.name.payment);
        e.selectedItem?.data?.bic && await saveOneFieldOnBlurFocus('bic', e.selectedItem?.data?.bic);
        e.selectedItem?.data?.correspondent_account && await saveOneFieldOnBlurFocus('cor_account', e.selectedItem?.data?.correspondent_account);
        await getListZayavka()
    }

    // select договора
    const onChangeDogovor = async (e) => {
        const selected = reqs.find(item => item.id === e.value)
        if (selected) {
            setSelectedReq(selected)
            setNewdogFiles(new Map())
            setDisabledForms(false)
        } else {
            setSelectedReq(reqs[0])
            setNewdogFiles(new Map())
            setDisabledForms(false)
        }
    }

    const renderField = (data) => {
        return (
            <TextBox value={data ? `${data.ndog || ''} ${data.name || ''}` : ''}/>
        );
    }

    const addFileToReq = async (type, files) => {
        const source = new Map(newdogFiles)
        if (files.length > 0) {
            files.forEach(e => {
                if (!e.delfiles) {
                    source.set(e.name, {
                        id: source.size + 1000000,
                        file_name: e.name,
                        file: e,
                    })
                } else {
                    source.delete(e.name)
                }
            })
        }
        setNewdogFiles(source)
        if (validateRequired) setTriangle(isFormValid(formRef[2]))
    }

    const addFiles = async (fd) => {
        if (newdogFiles.size > 0) {
            for (let newDogFile of newdogFiles.keys()) {
                fd.append('document', newdogFiles.get(newDogFile).file)
            }
            newdogFiles.clear()
        }
    }

    const downloadAkt = async (idAttach, isShowInNewWindow) => {
        setLoading(true)
        const res = await getRequestAttach( {id: selectedReq.id, kod_dog: selectedReq.kod_dog})
        if (res.isOk) {
            if (!isShowInNewWindow) {
                const data = res.data
                let fileDownload = require('js-file-download')
                fileDownload(Buffer.from(data.pdf_data.data), data.pdf_filename)
            } else {
                let blob = new Blob([new Uint8Array(res.data.attachment.data)], {type: "application/pdf"});
                const blobUrl = URL.createObjectURL(blob);
                // Открываем в новом окне
                const newWindow = window.open(blobUrl, '_blank');
                // Освобождаем память после загрузки
                if (newWindow) {
                    newWindow.onload = () => {
                        URL.revokeObjectURL(blobUrl);
                    };
                }
            }
        } else notify(res.message, 'error',10000)
        setLoading(false)
    }

    const recalcPlanVolume = (contrPrice, formData, formComponent) => {
        const data = formData || {}
        const existingPlanVol = Number(data.plan_volume)
        // Уже задан пользователем (или ранее) ненулевой объём — не пересчитываем
        if (existingPlanVol) return
        const priceKwh = Number(data.price_kwh)
        const price = Number(contrPrice)
        if (!price || !priceKwh || priceKwh <= 0) return
        const planVolume = Math.round(price / priceKwh)
        if (formComponent?.updateData) {
            formComponent.updateData('plan_volume', planVolume)
        }
        setSelectedReq((prev) => ({
            ...prev,
            plan_volume: planVolume,
        }))
        saveOneFieldOnBlurFocus('plan_volume', planVolume)
    }

    const recalcBudgetAmt = (formData, formComponent) => {
        const data = formData || {}
        if (!data.offbudget_funds) return
        const contrPrice = Number(data.contr_price)
        const otherAmt = Number(data.other_fund_amt)
        if (!Number.isFinite(contrPrice) || !contrPrice) return
        if (!Number.isFinite(otherAmt)) return
        const budgetAmt = Math.max(0, Math.round(contrPrice - otherAmt))
        if (Number(data.budget_amt) === budgetAmt) return
        if (formComponent?.updateData) {
            formComponent.updateData('budget_amt', budgetAmt)
        }
        setSelectedReq((prev) => ({
            ...prev,
            budget_amt: budgetAmt,
        }))
        saveOneFieldOnBlurFocus('budget_amt', budgetAmt)
    }

    return (
        <div className={'content-block dx-card responsive-paddings budget'}>
            <>
                <LoadPanel visible={loading} />
                <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faFileLines} />
                <h3><strong>Бюджетный потребитель{/*<ZagolovokFromMenu/>*/}</strong></h3>
                Создание черновика заявление на заключение контракта (договора) энергоснабжения на следующий период
                <SelectBox labelMode={'floating'} label={'Контракт (договор)'} className="big-input mt-4"
                           noDataText="Нет контрактов для отображения"
                           placeholder="Выберите контракт.."
                           dataSource={reqs}
                           displayExpr="name"
                           valueExpr={"id"}
                           value={selectedReq.id ? selectedReq.id : null}
                           onValueChanged={(e) => {
                               setValidateRequiredFlag(false)
                               onChangeDogovor(e);
                           }}
                           searchEnabled={true}
                           itemRender={(e) => <div><span className='small'>{e.ndog}</span> {e.name}</div>}
                           fieldRender={renderField}

                >
                </SelectBox>
                <Accordion
                    ref={accordionRef}
                    className={'mt-4 add-dogovor-tat'}
                    animationDuration={300}
                    id="accordion-container"
                    multiple={true}
                    collapsible={true}
                    triangle={triangle}
                >
                    {/* ================= БЛОК 1: ОБЩИЕ СВЕДЕНИЯ ================= */}
                    <AccItem titleRender={() => (
                        <div>
                            <i style={{
                                fontSize: '16px', color: 'red', marginRight: '10px',
                                display: isFormValid(formRef[0]) ? 'none' : 'inline'
                            }} className="dx-icon-warning"></i>
                            <span>Общие сведения</span>
                        </div>
                    )}>
                        <form>
                            <Form
                                disabled={disabledForms}
                                ref={formRef[0]}
                                formData={selectedReq}
                                id="budget-form1"
                                labelMode="floating"
                                labelLocation="left"
                                onFieldDataChanged={(e) => {
                                    if (validateRequired) setTriangle(isFormValid(formRef[0]));
                                    const formData = {
                                        ...(e.component.option('formData') || {}),
                                        [e.dataField]: e.value,
                                    }
                                    if (e.dataField === 'contr_price') {
                                        recalcPlanVolume(e.value, formData, e.component)
                                    }
                                    if (e.dataField === 'other_fund_amt' || e.dataField === 'contr_price') {
                                        recalcBudgetAmt(formData, e.component)
                                    }
                                    saveOneFieldOnBlurFocus(e.dataField, e.value);
                                }}
                            >
                                    {/* Вид контракта - на всю ширину */}

                                <Item dataField="type" editorType="dxSelectBox" editorOptions={{
                                    placeholder: "Вид контракта (договора)",
                                    dataSource: contractTypes,
                                    displayExpr: "name",
                                    valueExpr: "id",
                                }} isRequired={true}>
                                    <Label text={'Вид контракта (договора)'} />
                                    <CustomRule message="Вид контракта обязателен" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                </Item>

                            <GroupItem colCount={2}>
                                    {/* Период действия - 2 колонки (даты) */}
                                    <Item dataField="contr_date_start" editorType="dxDateBox" editorOptions={dateOptions} isRequired={true}>
                                        <Label text={"Период действия: с"} />
                                        <CustomRule message="Дата начала обязательна" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                    </Item>
                                    <Item dataField="contr_date_stop" editorType="dxDateBox" editorOptions={dateOptions} isRequired={true}>
                                        <Label text={"Период действия: по"} />
                                        <CustomRule message="Дата окончания обязательна" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                    </Item>
                            </GroupItem>
                                    {/* Основание закупки - на всю ширину */}
                                        <Item dataField="reason" editorType="dxSelectBox" editorOptions={{
                                            placeholder: "Основание закупки",
                                            dataSource: reasonList,
                                            displayExpr: "name",
                                            valueExpr: "id",
                                        }} isRequired={true}>
                                            <Label text={'Основание закупки'} />
                                            <CustomRule message="Основание обязательно" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                        </Item>

                                    {/* Идентификационный код закупки - на всю ширину */}
                                        <Item dataField="proc_id" editorType="dxTextBox">
                                            <Label text={"Идентификационный код закупки"} />
                                            <StringLengthRule max={100} message="Максимум 100 символов" />
                                        </Item>

                                    {/* Числовые поля - по 2 в строке */}
                                <GroupItem colCount={3}>
                                    <Item dataField="est_price" editorType="dxNumberBox" editorOptions={{ disabled: true, format: MONEY_FORMAT }}>
                                        <Label text={"Прогнозируемая цена контракта, руб."} />
                                    </Item>
                                    <Item dataField="est_volume" editorType="dxNumberBox" editorOptions={{ disabled: true, format: VOLUME_FORMAT }}>
                                        <Label text={"Прогнозируемый объем, кВтч"} />
                                    </Item>

                                    <Item dataField="price_kwh" editorType="dxNumberBox" editorOptions={{ disabled: true, format: PRICE_KWH_FORMAT }}>
                                        <Label text={"Цена за 1 кВтч с НДС, руб."} />
                                    </Item>
                                </GroupItem>
                                <GroupItem colCount={2}>
                                    <Item dataField="contr_price" editorType="dxNumberBox" editorOptions={{
                                        format: MONEY_FORMAT,
                                    }} isRequired={true}>
                                        <Label text={"Цена контракта (договора), руб."} />
                                        <CustomRule message="Цена контракта обязательна" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                    </Item>

                                    <Item dataField="plan_volume" editorType="dxNumberBox" editorOptions={{ format: VOLUME_FORMAT }}>
                                        <Label text={"Планируемый объем, кВтч"} />
                                    </Item>
                                </GroupItem>
                                    <Item></Item>
                                    {/* Галка - на всю ширину */}
                                    <Item colSpan={2} dataField={'incl_plan_vol'} editorType={'dxCheckBox'}  editorOptions={{
                                        text: 'Включать планируемый объем в контракт'
                                    }}>
                                        <Label visible={false} />
                                    </Item>
                                    {/* Источник финансирования - на всю ширину */}
                                    <GroupItem colSpan={2}>
                                        <Item dataField="fund_source" editorType="dxSelectBox" editorOptions={{
                                            placeholder: "Источник финансирования",
                                            dataSource: fundSourceList,
                                            displayExpr: "name",
                                            valueExpr: "id",
                                        }} isRequired={true}>
                                            <Label text={'Источник финансирования'} />
                                            <CustomRule message="Источник обязателен" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                        </Item>
                                    </GroupItem>

                                    {/* Галка внебюджетных средств */}
                                    <Item colSpan={2} dataField={'offbudget_funds'} editorType={'dxCheckBox'}   editorOptions={{
                                        text: 'Используются внебюджетные средства',
                                        onValueChanged:async (e) => {
                                            setSelectedReq(prev => {
                                                // Тут можно написать какой-то дополнительный код
                                                return {
                                                    ...prev,
                                                    [e.dataField]: e.value
                                                };
                                            });
                                        },
                                    }}>
                                        <Label visible={false} />
                                    </Item>
                                    {/* Условные поля - только если offbudget_funds === true */}
                                    {selectedReq?.offbudget_funds && (
                                        <Item  colSpan={2} dataField="other_fund" editorType="dxTextBox">
                                            <Label text={"Иной источник финансирования"} />
                                            <StringLengthRule max={500} message="Максимум 500 символов" />
                                        </Item>
                                    )}
                                    {selectedReq?.offbudget_funds && (
                                        <Item dataField="other_fund_amt" editorType="dxNumberBox" editorOptions={{ format: MONEY_FORMAT }}>
                                            <Label text={"Денежные средства из иного источника, руб."} />
                                        </Item>
                                    )}
                                    {selectedReq?.offbudget_funds && (
                                        <Item dataField="budget_amt" editorType="dxNumberBox" editorOptions={{ format: MONEY_FORMAT }}>
                                            <Label text={"Денежные средства из бюджета, руб."} />
                                        </Item>
                                    )}
                            </Form>
                        </form>
                    </AccItem>

                    {/* ================= БЛОК 2: БАНКОВСКИЕ РЕКВИЗИТЫ (без изменений) ================= */}
                    <AccItem titleRender={() => (
                        <div>
                            <i style={{ fontSize: '16px', color: 'red',marginRight: '10px', display: isFormValid(formRef[1]) ? 'none':'inline'}} className="dx-icon-warning"></i>
                            <span>Банковские реквизиты</span>
                        </div>
                    )}>
                        <form className="">
                            <Form disabled={disabledForms}
                                  ref={formRef[1]}
                                  formData={selectedReq}
                                  id="dogovor-form2"
                                  colCount={2}
                                  labelMode= "floating"
                                  labelLocation="left"
                                  onFieldDataChanged={ (e) => {
                                      if (validateRequired) setTriangle(isFormValid(formRef[1]));
                                      saveOneFieldOnBlurFocus(e.dataField, e.value)
                                  }
                                  }

                            >
                                <GroupItem colCount={2} colSpan={2}>
                                    <Item
                                        dataField="bank"
                                        editorType="dxAutocomplete"
                                        editorOptions={{
                                            showClearButton: true,
                                            dataSource: bankStore,
                                            valueExpr: "unrestricted_value",
                                            placeholder: "Начните вводить название банка или бик...",
                                            minSearchLength: 1,
                                            searchTimeout: 300,
                                            valueChangeEvent: "blur",
                                            validationMessagePosition: "top",
                                            onSelectionChanged: selectionChangedBank
                                        }} isRequired={true}>
                                        <Label text="Банк" />
                                        <CustomRule message="Банк обязателен" validationCallback={requiredWhenSubmitting} reevaluate={true} />

                                    </Item>

                                    <Item dataField="bic" editorType="dxAutocomplete" editorOptions={{
                                        inputAttr: { maxLength: 9, pattern: '\\d*' },
                                        format: '#',
                                        valueChangeEvent: "blur",
                                        showClearButton: true,
                                        dataSource: bankStore,
                                        valueExpr: "bic",
                                        placeholder: "Начните вводить бик...",
                                        minSearchLength: 1,
                                        validationMessagePosition: "top",
                                        onSelectionChanged: selectionChangedBank,
                                        onInput: (e) => {
                                            e.event.target.value = e.event.target.value.replace(/\D/g, '');
                                        },
                                    }} isRequired={true}>
                                        <Label text={"БИК"} />
                                        <CustomRule message="БИК обязателен" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                        <StringLengthRule max={9} message="Бик должен содержать ровно 9 цифр" />
                                        <PatternRule pattern="^\d{9}$" message="БИК должен содержать ровно 9 цифр" />
                                    </Item>

                                    <Item dataField="pay_account" editorType="dxTextBox" editorOptions={{
                                        inputAttr: { maxLength: 20, pattern: '\\d*' },// Ограничение длины ввода до 20 символов
                                        validationMessagePosition:"top",
                                        format: '#',
                                        onInput: (e) => {
                                            // Оставляем только цифры в поле ввода
                                            e.event.target.value = e.event.target.value.replace(/\D/g, '');
                                        },
                                    }}
                                     isRequired={true}>
                                        <Label text={"Расчетный счет"} />
                                        <CustomRule message="Расчетный счет обязателен" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                        <StringLengthRule max={20} message={`Расчетный счет должен содержать ровно 20 цифр`} />
                                        <PatternRule pattern="^\d{20}$" message="Расчетный счет должен содержать ровно 20 цифр" />
                                    </Item>

                                    <Item dataField="cor_account" editorType="dxTextBox" editorOptions={{
                                        inputAttr: { maxLength: 20, pattern: '\\d*' }, // Ограничение длины ввода до 20 символов
                                        format: '#',
                                        onInput: (e) => {
                                            // Оставляем только цифры в поле ввода
                                            e.event.target.value = e.event.target.value.replace(/\D/g, '');
                                        },
                                        validationMessagePosition:"top",
                                    }} isRequired={true}>
                                        <Label text={"Корр.счет"} />
                                        <CustomRule message="Корр.счет обязателен" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                        <StringLengthRule max={20} message="Корр.счет должен содержать ровно 20 цифр" />
                                        <PatternRule pattern="^\d{20}$" message="Корр.счет должен содержать ровно 20 цифр" />
                                    </Item>

                                    <Item
                                        dataField="treasury_name"
                                        editorType="dxAutocomplete"
                                        editorOptions={{
                                            showClearButton: true,
                                            dataSource: treasuryList,
                                            valueExpr: "name",
                                            searchExpr: ["name", "allname"],
                                            minSearchLength: 0,
                                            placeholder: "Начните вводить название казначейства...",
                                            valueChangeEvent: "blur",
                                        }}
                                    >
                                        <Label text={"Название казначейства"} />
                                        <StringLengthRule max={500} message="Максимум 500 символов" />
                                    </Item>
                                    <Item dataField="treasury_num" editorType="dxTextBox">
                                        <Label text={"Номер лицевого счёта"} />
                                        <StringLengthRule max={100} message="Максимум 100 символов" />
                                    </Item>
                                </GroupItem>
                            </Form>
                        </form>
                    </AccItem>

                    {/* ================= БЛОК 3: КОНТАКТНЫЕ ДАННЫЕ ================= */}
                    <AccItem titleRender={() => (
                        <div>
                            <i style={{
                                fontSize: '16px', color: 'red', marginRight: '10px',
                                display: isFormValid(formRef[2]) ? 'none' : 'inline'
                            }} className="dx-icon-warning"></i>
                            <span>Контактные данные</span>
                        </div>
                    )}>
                        <form>
                            <Form
                                disabled={disabledForms}
                                ref={formRef[2]}
                                formData={selectedReq}
                                id="budget-form3"
                                labelMode="floating"
                                labelLocation="left"
                                onFieldDataChanged={(e) => {
                                    if (validateRequired) {
                                        setTriangle(isFormValid(formRef[2]))
                                    }
                                    saveOneFieldOnBlurFocus(e.dataField, e.value);
                                }}
                            >
                                <GroupItem>
                                    <p className="form-hint">
                                        Контакты ответственных лиц потребителя будут указаны в разделе 10 договора
                                        «Реквизиты сторон». Заполнение данных является обязательным.
                                    </p>
                                </GroupItem>

                                {/* --- Контакты для уведомлений о введении ограничения --- */}
                                <GroupItem>
                                    <h4 className="form-subtitle">Контакты для получения уведомлений о введении ограничения</h4>
                                </GroupItem>
                                <GroupItem colCount={3}>
                                    <Item dataField="notif_contact" editorType="dxTextBox" isRequired={true}>
                                        <Label text={"ФИО"} />
                                        <CustomRule message="ФИО обязательно" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                    </Item>
                                    <Item dataField="notif_phone" editorOptions={{ mask: '+7 (000) 000-0000' }} editorType="dxTextBox" isRequired={true}>
                                        <Label text={"Телефон"} />
                                        <CustomRule message="Телефон обязателен" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                    </Item>
                                    <Item dataField="notif_email" editorType="dxTextBox" editorOptions={{ mode: 'email' }} isRequired={true}>
                                        <Label text={"Email"} />
                                        <CustomRule message="Email обязателен" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                        <EmailRule message="Email задан неверно" />
                                    </Item>
                                </GroupItem>

                                    {/* --- Лицо, ответственное за приборы учета --- */}
                                <GroupItem>
                                    <h4 className="form-subtitle">Лицо, ответственное за приборы учета и показания</h4>
                                </GroupItem>
                                <GroupItem colCount={3}>
                                    <Item dataField="meter_resp" editorType="dxTextBox" isRequired={true}>
                                        <Label text={"ФИО"} />
                                        <CustomRule message="ФИО обязательно" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                    </Item>
                                    <Item dataField="meter_phone" editorOptions={{ mask: '+7 (000) 000-0000' }} editorType="dxTextBox" isRequired={true}>
                                        <Label text={"Телефон"} />
                                        <CustomRule message="Телефон обязателен" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                    </Item>
                                    <Item dataField="meter_email" editorType="dxTextBox" editorOptions={{ mode: 'email' }} isRequired={true}>
                                        <Label text={"Email"} />
                                        <CustomRule message="Email обязателен" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                        <EmailRule message="Email задан неверно" />
                                    </Item>
                                </GroupItem>

                                    {/* --- Лицо, ответственное за взаиморасчеты --- */}
                                <GroupItem>
                                    <h4 className="form-subtitle">Лицо, ответственное за взаиморасчеты</h4>
                                </GroupItem>
                                <GroupItem colCount={3}>
                                    <Item dataField="settle_resp" editorType="dxTextBox" isRequired={true}>
                                        <Label text={"ФИО"} />
                                        <CustomRule message="ФИО обязательно" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                    </Item>
                                    <Item dataField="settle_phone" editorOptions={{ mask: '+7 (000) 000-0000' }} editorType="dxTextBox" isRequired={true}>
                                        <Label text={"Телефон"} />
                                        <CustomRule message="Телефон обязателен" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                    </Item>
                                    <Item dataField="settle_email" editorType="dxTextBox" editorOptions={{ mode: 'email' }} isRequired={true}>
                                        <Label text={"Email"} />
                                        <CustomRule message="Email обязателен" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                        <EmailRule message="Email задан неверно" />
                                    </Item>
                                </GroupItem>


                                    {/* --- Руководитель (подписант) --- */}
                                <GroupItem colSpan={2}>
                                    <h4 className="form-subtitle">Руководитель (подписант)</h4>
                                </GroupItem>
                                <GroupItem colCount={3}>
                                    <Item dataField="signer_name" editorType="dxTextBox" isRequired={true}>
                                        <Label text={"ФИО руководителя (подписанта)"} />
                                        <CustomRule message="ФИО обязательно" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                    </Item>
                                    <Item dataField="signer_title" editorType="dxTextBox" isRequired={true}>
                                        <Label text={"Должность руководителя (подписанта)"} />
                                        <CustomRule message="Должность обязательна" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                    </Item>
                                    <Item dataField="auth_basis" editorType="dxTextBox" isRequired={true}>
                                        <Label text={"Действует на основании"} />
                                        <CustomRule message="Основание обязательно" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                    </Item>
                                </GroupItem>
                                <GroupItem colSpan={3}>
                                    <Item>
                                        <div className={'my-3'}>
                                            <ul>
                                                {
                                                    Array.from(newdogFiles.keys()).map(e => (
                                                        <li key={e}>{e}</li>
                                                    ))
                                                }
                                            </ul>
                                            <Button className="" text="Добавить документы" icon="add" onClick={() => {
                                                setVisibleAddOldFiles(true)
                                            }}/>
                                            <NewdogFiles typeFileLimit={'newdog'} maxLengthFileName={124} visible={visibleAddOldFiles}
                                                         types={dogDocList} onClose={() => setVisibleAddOldFiles(false)}
                                                         onAddFiles={addFileToReq} visibleSelectBox={true}/>
                                        </div>
                                    </Item>
                                </GroupItem>

                                    {/* --- Контактное лицо --- */}
                                <GroupItem colSpan={2}>
                                    <h4 className="form-subtitle">Контактное лицо</h4>
                                </GroupItem>
                                <GroupItem colCount={3}>
                                    <Item dataField="app_contact" editorType="dxTextBox" isRequired={true}>
                                        <Label text={"ФИО"} />
                                        <CustomRule message="ФИО обязательно" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                    </Item>
                                    <Item dataField="app_phone" editorOptions={{ mask: '+7 (000) 000-0000' }} editorType="dxTextBox" isRequired={true}>
                                        <Label text={"Телефон"} />
                                        <CustomRule message="Телефон обязателен" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                    </Item>
                                    <Item dataField="app_email" editorType="dxTextBox" editorOptions={{ mode: 'email'}} isRequired={true}>
                                        <Label text={"Email"} />
                                        <CustomRule message="Email обязателен" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                        <EmailRule message="Email задан неверно" />
                                    </Item>
                                </GroupItem>
                            </Form>
                        </form>
                    </AccItem>
                </Accordion>
                <div className='agreement-row mt-4'>
                    <form  className="agreement-wrapper">
                        <Form
                            className="mt-4"
                            visible={!disabledForms}
                            ref={formRef[3]}
                            formData={selectedReq}
                            id="dogovor-form5"
                            colCount={1}
                            labelMode= "floating"
                            labelLocation="left"
                        >
                            <Item dataField="accepted"
                                  editorType="dxCheckBox"
                                  isRequired={true}>
                                <Label visible={false} />
                                <CompareRule message="Необходимо принять условия обработки данных"
                                             comparisonTarget={() => true}
                                             ignoreEmptyValue={false}
                                />
                            </Item>
                        </Form>
                    </form>
                    {!disabledForms &&
                        <span className='check-box-tatenergo'>Принимаю <a href={policyUrl} target="_blank" rel="noopener noreferrer">условия обработки данных</a></span>
                    }
                </div>
                <div className='my-3'>
                    Контракт (договор): {selectedReq.ndog}<br/>
                    <Button className='mr-3 my-2' hint='Скачать' text="Скачать файл в формате PDF" type='default' icon='download' onClick={ async () => await downloadAkt(null, false)}></Button>
                    <br/><span className={'text-secondary'}>Сформированный черновик заявления будет храниться в Личном кабинете в течение 30 дней и
                    доступен для изменения</span>
                </div>

                <p>После того, как Вы нажмете «Направить заявление», оно поступит в ООО «Р-Энергия», будет зарегистрировано и принято в работу.
                    Вы сможете узнать о статусе рассмотрения заявления в разделе «Диалоги».<br/>
                    В срок не более 10 рабочих дней Вы получите проект договора (контракта) энергоснабжения в системе электронного документооборот.
                </p>

                <div className='mt-4 float-right mr-4'><Button className="block" icon="email" disabled={disabledForms} type={'default'} text="Направить заявление" hint="Отправить заявку" onClick={() => onSendRequest(true)}/></div>
                <div className='mt-4 float-right mr-4'><Button className="block" icon="edit" disabled={disabledForms} type={'default'} text="Сохранить черновик" hint="Сохранить черновик" onClick={() => onSendRequest(false)}/></div>
                <div className='mt-4 float-right mr-4'><Button className="align-self-end block" disabled={disabledForms} text="< Назад" hint="Назад" onClick={() => history.push('/budget')}/></div>
                <ErrorPopup text={popupErrorText}
                            icon = {popupIcon}
                            width={popupWidth}
                            title ={popupTitle}
                            btnVisible={true}
                            visible={popupErrorVisible}
                            onOk={onOk}
                            classNameColorIcon={popupClassNameColorIcon}
                            btnVisibleCancel={btnVisibleCancel}
                            onCancel={onCancel}
                            onCancelWithOk={onCancelWithOk ?? onCancel}
                />
            </>
        </div>
    )
}

export default AddContractPage
